import { render } from "./SubmenuVerticalB.vue?vue&type=template&id=63902e79&scoped=true"
const script = {}

import "./SubmenuVerticalB.vue?vue&type=style&index=0&id=63902e79&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63902e79"]])

export default __exports__